import { useState, useEffect } from "react";
import {
  collection,
  onSnapshot,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../config/firebase";

export const useKits = () => {
  const [kits, setKits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "kits"), (snapshot) => {
      const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      data.sort((a, b) => {
        const aO = a.order ?? Infinity;
        const bO = b.order ?? Infinity;
        return aO - bO;
      });
      setKits(data);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const addKit = async (kitName, kitItems, createdBy) => {
    await addDoc(collection(db, "kits"), {
      kitName,
      items: kitItems,
      createdBy,
      order: kits.length,
      createdAt: serverTimestamp(),
    });
  };

  const updateKit = async (kitId, kitName, kitItems) => {
    await updateDoc(doc(db, "kits", kitId), {
      kitName,
      items: kitItems,
      updatedAt: serverTimestamp(),
    });
  };

  const deleteKit = async (kitId) => {
    await deleteDoc(doc(db, "kits", kitId));
  };

  const reorderKits = async (orderedIds) => {
    await Promise.all(
      orderedIds.map((id, i) => updateDoc(doc(db, "kits", id), { order: i }))
    );
  };

  return { kits, loading, addKit, updateKit, deleteKit, reorderKits };
};
